'use strict';

angular.module('shiftTraderApp')
  .controller('TradeDialogSvrCtrl', function ($scope, $filter, $timeout, ShiftTradesResource, TradeRecommendations, WorkPeriods, TimeService, $uibModalInstance, me, workPeriod, mode, org, allPositions) {
    $scope.me = me;
    $scope.workPeriod = workPeriod;
    $scope.mode = mode; // 'trade' or 'giveaway' depending on context of initialization
    $scope.modalInstance = $uibModalInstance;
    $scope.allPositions = allPositions;
    $scope.org = org;

    if ($scope.mode.mode === 'trade') {
      TradeRecommendations.getTradeRecForWpId($scope.workPeriod.id)
        .then(function(tr) {
          $scope.tradeRecommendation = tr;
          $scope.workPeriodsToDisplay = tr.workPeriods;
          $scope.workPeriodsForTradingLoaded = true;
        }, function() {
          console.log('whoops! TradeRecommendations wouldnt load');
        });
    }

    $scope.workPeriodsForTradingLoaded = false;

    $scope.close = function() {
      $uibModalInstance.close('close');
    };

    $scope.createGiveAway = function() {
      var giveaway = {
        user_id: $scope.workPeriod.user.id,
        work_period_id: $scope.workPeriod.id,
        message: '',
        organization_id: $scope.workPeriod.organization.id
      };
      ShiftTradesResource.save({}, giveaway, function(createdGiveAway) {
        $uibModalInstance.close(createdGiveAway);
      });
    };
  });
